import { Stack } from "@mui/material";
import { ErrorText, FormLabel, HelperText } from "../elements/Elements";

export const FieldWrapper = ({
  children,
  label,
  helperText,
  error,
  field,
  required,
  ...props
}: {
  children: any;
  label?: any;
  helperText?: any;
  error?: any;
  field?: any;
  required?: any;
}) => {
  const { noLabel }: any = props || {};
  return (
    <Stack spacing={1} width="100%">
      {!noLabel && (
        <FormLabel required={required} {...props}>
          {label}
        </FormLabel>
      )}
      {children}
      <HelperText text={helperText} />
      <ErrorText>{error?.[field]}</ErrorText>
    </Stack>
  );
};
